import React, { Component } from "react";
import socketIOClient from "socket.io-client";
import { httpUploadFile, URLS } from "./../network";
import download from "downloadjs"
import { isNullOrEmpty, SCRAPING_PAGE_TYPE, toObject  } from "./../utils";

class BoletinMineria extends Component {

    constructor() {
        super();
      
        this.state = {
            fileName: "",
            fileChoicePath: "",
            rows: [],
            showLoader: false,
            currentRevision: "",
            maxRows: 0,
            currentRow: 0
        }
    }

    componentDidMount() {
        this.fileSelector = this.buildFileSelector();
    }

    componentDidUpdate() {
        this.scrollToBottom();
    }

    scrollToBottom = () => {
        this.messagesEnd.scrollIntoView({ behavior: "smooth" });
    }
    
    buildFileSelector = () => {
		
        const fileSelector = document.createElement("input");
        fileSelector.setAttribute("type", "file");
        fileSelector.setAttribute("multiple", "multiple");
    
        fileSelector.onchange = this.parseFile();
        return fileSelector;
    };

    parseFile = () => (e) => {

        const file = e.target.files[0];
        this.setState({fileChoicePath: file, fileName: file.name });
    };
        
    onFileClickSelect = () => (e) => {
        e.preventDefault();
        this.fileSelector.click();
    };


    downloadFileResult (filename) {

        fetch(URLS.DOWNLOAD_FILE + "?file="+filename)
            .then ((res) => {
                return res.blob();
            })
            .then ( (blob) => {
                download(blob, "bm_coincidencias.txt", "text/plain");
            })
            .catch( (err) => {
                console.log (err);
            });
    }

    onSearchClick = async () => {
        
        if ( isNullOrEmpty( this.state.fileName)) {
            alert("Debes cargar primero un archivo!");
            return;
        }

        const fileData = await httpUploadFile(URLS.UPLOAD_FILE, { newFile: this.state.fileChoicePath});
        
        const socket = socketIOClient(URLS.MAIN_URL, {  query: "type="+ SCRAPING_PAGE_TYPE.BoletinMineria});
        socket.on("connection", (data) => {
            console.log (data);
        });

        socket.on("on_row_incoming", (data) => {
            const payload = toObject(data);
            if (!payload || !payload.tender) {
                return;
            }

            let currentrows = this.state.rows;
            currentrows.push(payload.tender);
            this.setState({ rows: currentrows });
        });

        socket.on ("on_process_end", (filename) => {
            
            socket.emit("disconnect");
            socket.disconnect();
            this.setState({showLoader: false, currentRevision: "", currentRow: 0});

            this.downloadFileResult(filename);
        });

        socket.on("on_rows_to_proccess", (rowsNumber) => {
            this.setState({maxRows: rowsNumber});
        })

        socket.on("on_error", (errObj) => {

            this.setState({showLoader: false, currentRevision: "", currentRow: 0});

            const err = errObj.err;
            this.props.errorMessage(err.message);
            socket.emit("disconnect");
            socket.disconnect();

            if ( !isNullOrEmpty(errObj.file)) {
                this.downloadFileResult(errObj.file);
            }
        });

        socket.on("on_current_processing", (data) => {
            this.setState({currentRevision: data.text, currentRow: data.number});
        });
        
        this.setState({rows: [], showLoader: true, fileName: fileData.realname, currentRevision: "", currentRow: 0 });
        socket.emit("process_start", { path: fileData.path });
    }

    onChangeInput = (e) => {
		this.setState({ [e.target.name]: e.target.value });
	};

    render () {
        return (
            <div className="pjud-container">
                <h3>Diario Oficial</h3>
                <p>
                    Búsqueda de una palabra en el sumario del boletín. Se extrae la palabra encontrada mas un bloque de texto que la rodea. <br/>
                    En el archivo de búsqueda Las palabalas deben estar en mayusculas y sin tilde. Documento adjunto de ejemplo(debe ser un xml)<br />
                    <a href={URLS.MAIN_URL + "assets/bm_ejemplo.xml"} target="_blank" rel="noopener noreferrer">
                        <span className="fas fa-file-excel pjud-excel-icon" title="Documento de ejemplo"></span>
                    </a>
                </p>
                
                <div className="pjud-option-container">
                    <fieldset className="scheduler-border" >
                        <legend className="scheduler-border">Selecciona el archivo con palabras a buscar</legend>
                        <div className="filter-doc-file">
                            <input type="text" id="filterIdsTxt" className="form-control"
                                placeholder="Selecciona archivo" value={this.state.fileName}/>
                            <button className="btn btn-outline-primary" onClick={this.onFileClickSelect()}> Abrir</button>
                        </div>
                    </fieldset>
                </div>

                <div className="progress-container">
                    {this.state.currentRevision}
                    <div className="progress-state">
                        { this.state.showLoader && <div id="loader" className="loader-seia"></div> }
                        <label id="currentProgress">{"Leido " + this.state.currentRow + " de " + this.state.maxRows}</label>
                    </div>
                    <button className="btn btn-outline-primary" onClick={this.onSearchClick}>Buscar</button>
                </div>
                
                <div id="tableContainer" className="result-table">
                    <table className="table table-striped table-fixed">
                        <thead>
                            <tr>
                                <th scope="col">Día</th>
                                <th scope="col">Encontrados</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.state.rows.map( (row, index) => {
                                    
                                    return (
                                        <tr key={index}>
                                            <td className="first-table-row">{row.date}</td>
                                            <td >{ row.found === null ? "No se encotraron coincidencias" : JSON.stringify(row.found)}</td>
                                        </tr>
                                    );
                                })   
                            }
                        
                        </tbody>
                    </table>
                    <div style={{ float:"left", clear: "both" }}
                        ref={(el) => { this.messagesEnd = el; }}>
                    </div>
                </div>
            </div>
        );
    }
    
}

export default BoletinMineria;